import React from 'react';
import { useTranslation } from 'react-i18next';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { HelpCircle } from 'lucide-react';

/**
 * FAQ section — accordion of 5 common questions to lift last objections
 * before booking. Fully translated FR / NL / EN via i18n.
 */
export default function FAQSection() {
  const { t } = useTranslation();
  const items = [
    { q: t('faq.q1'), a: t('faq.a1') },
    { q: t('faq.q2'), a: t('faq.a2') },
    { q: t('faq.q3'), a: t('faq.a3') },
    { q: t('faq.q4'), a: t('faq.a4') },
    { q: t('faq.q5'), a: t('faq.a5') },
  ];

  return (
    <section className="bg-[#F9F9F7] py-20" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-[#C77D63]/15 mb-4">
            <HelpCircle className="w-6 h-6 text-[#C77D63]" />
          </div>
          <h2 className="font-heading text-3xl sm:text-4xl font-bold text-black tracking-tight">
            {t('faq.title')}
          </h2>
          <p className="mt-2 text-base text-black/70">{t('faq.subtitle')}</p>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {items.map((it, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              data-testid={`faq-item-${i}`}
              className="bg-white border border-[#E2E2DF] rounded-xl px-5 hover:border-[#C77D63]/60 transition-colors"
            >
              <AccordionTrigger className="font-heading text-base sm:text-lg text-left text-[#1A3C34] hover:no-underline py-5">
                {it.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm sm:text-[15px] text-black/75 leading-relaxed pb-5">
                {it.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
